import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import ArrowIcon from '../components/svgs/arrow-right'

import './interviste.sass'
import { FormattedMessage } from 'react-intl'

export default class IntervistePage extends Component {
  render() {
    let locale = 'it'

    if (typeof window !== 'undefined') {
      locale = window.localStorage.getItem('locale')
    }

    const interviews = this.props.data.allDatoCmsInterview.edges
      .map(edge => edge.node)
      .filter(node => node.locale === locale)

    const linkPrefix = locale === 'it' ? '' : '/en'

    return (
      <div>
        <Helmet>
          <title>
            Interviste | L'architettura nel Cantone Ticino, 1945 - 1980
          </title>
        </Helmet>
        <div className="Interviste wrap-narrower">
          <h1 className="text-primary mb-3">
            <FormattedMessage id="menu.interviste" />
          </h1>

          <div className="Interviste__List">
            {interviews.map((interview, index) => (
              <Link
                key={index}
                to={`${linkPrefix}${interview.fields.path}`}
                className="Interviste__ListItem"
              >
                <div className="Interviste__ListItem__Text with-arrow-icon">
                  <div className="Interviste__ListItem__Title">
                    {interview.titolo}
                  </div>
                  <div
                    className="Interviste__ListItem__Body"
                    dangerouslySetInnerHTML={{ __html: interview.abstract }}
                  />
                  <ArrowIcon className="Interviste__ListItem__ArrowIcon" />
                </div>
                {interview.video && (
                  <div className="Interviste__ListItem__Image">
                    <img
                      className="img-responsive"
                      src={interview.video.thumbnailUrl}
                    />
                  </div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query Interview {
    allDatoCmsInterview(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          titolo
          locale
          abstract
          video {
            thumbnailUrl
          }
          fields {
            path
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/interviste.js